import { render, staticRenderFns } from "./ClassroomInfo.vue?vue&type=template&id=30935037&scoped=true&"
import script from "./ClassroomInfo.vue?vue&type=script&lang=js&"
export * from "./ClassroomInfo.vue?vue&type=script&lang=js&"
import style0 from "./ClassroomInfo.vue?vue&type=style&index=0&id=30935037&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30935037",
  null
  
)

export default component.exports